import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const AnimatedBlock = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const through = [
  "la morte.",
  "il lutto.",
  "il dolore.",
  "la perdita.",
  "il Fine Vita come Accompagnatrice Spirituale.",
  "le mie ferite pi\u00f9 profonde.",
];

const letGo = [
  "il \u201cnon sono abbastanza\u201d.",
  "il \u201cnon sono degna\u201d.",
  "il bisogno di piacere a tutti.",
  "la paura di essere vista.",
  "la paura della vulnerabilit\u00e0.",
  "la maschera della Salvatrice.",
  "ogni identit\u00e0 che non apparteneva pi\u00f9 alla mia Essenza.",
];

const OriginSection = () => {
  return (
    <section data-testid="origin-section" className="py-24 md:py-32 bg-[#F5F0EB]">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">

        {/* Photo before title */}
        <AnimatedBlock>
          <div className="mb-16 max-w-3xl mx-auto">
            <div className="rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgba(68,47,35,0.08)]">
              <img
                src="https://customer-assets-gfyr7b9c.emergentagent.net/job_inner-light-path-2/artifacts/6hvmd8ar_AlessiaStella-289.webp"
                alt="Alessia Stella - Light Workers House"
                className="w-full h-auto object-cover"
                data-testid="origin-photo"
              />
            </div>
          </div>
        </AnimatedBlock>

        <AnimatedBlock delay={0.05}>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-[#442F23] text-center mb-12">
            Da dove nasce Light Workers' House?
          </h2>
        </AnimatedBlock>

        <AnimatedBlock delay={0.1}>
          <p className="font-body text-base text-[#442F23]/80 text-center mb-8 leading-relaxed">
            Nasce dalla vita che mi ha chiesto di attraversare:
          </p>
          <ul className="space-y-2 mb-8 max-w-md mx-auto">
            {through.map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="text-[#AC8E60] font-body text-base mt-0.5">&rarr;</span>
                <span className="font-body text-base text-[#442F23]/80">{item}</span>
              </li>
            ))}
          </ul>
          <p className="font-body text-base text-[#442F23]/80 text-center leading-relaxed mb-12">
            Ogni esperienza sembrava scollegata.<br />
            Solo guardandomi indietro ho capito che stava costruendo la guida che sono oggi.<br />
            Perch&eacute; ogni ferita attraversata ha ampliato il mio modo di vedere, sentire e accompagnare l'essere umano.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.2}>
          <p className="font-body text-base text-[#442F23]/80 text-center mb-8 leading-relaxed">
            Poi la vita mi ha chiesto di lasciare andare:
          </p>
          <ul className="space-y-2 mb-12 max-w-md mx-auto">
            {letGo.map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="text-[#AC8E60] font-body text-base mt-0.5">&rarr;</span>
                <span className="font-body text-base text-[#442F23]/80">{item}</span>
              </li>
            ))}
          </ul>
        </AnimatedBlock>

        <AnimatedBlock delay={0.3}>
          <div className="text-center space-y-6">
            <p className="font-body text-base text-[#442F23]/80 leading-relaxed">
              Ho scoperto che ogni volta che attraversavo un'Ombra...<br />
              <strong>la mia Luce diventava pi&ugrave; intensa.</strong>
            </p>
            <p className="font-body text-base text-[#442F23]/80 leading-relaxed">
              Ogni volta che smettevo di tradirmi...<br />
              <strong>il mio Fuoco cresceva.</strong>
            </p>
            <p className="font-body text-base text-[#442F23]/80 leading-relaxed">
              Fino a diventare cos&igrave; grande da non riuscire pi&ugrave; a rimanere solo mio.
            </p>
          </div>
        </AnimatedBlock>

        <AnimatedBlock delay={0.4}>
          <div className="mt-12 py-8 border-t border-[#AC8E60]/15 text-center">
            <p className="font-heading text-xl md:text-2xl text-[#442F23] leading-relaxed mb-4">
              <strong>Light Workers' House</strong> nasce esattamente da questo.
            </p>
            <p className="font-body text-base text-[#442F23]/80 leading-relaxed mb-4">
              Dal desiderio di creare uno spazio dove il mio Fuoco possa diventare un catalizzatore del tuo.
            </p>
            <p className="font-body text-base text-[#AC8E60] leading-relaxed italic font-medium">
              Perch&eacute; quando una Fiamma &egrave; davvero viva...<br />
              ha una caratteristica straordinaria.<br />
              Non illumina soltanto.<br />
              <strong>Accende tutto ci&ograve; che incontra.</strong>
            </p>
          </div>
        </AnimatedBlock>
      </div>
    </section>
  );
};

export default OriginSection;
